import { determineIconAndClassName, GETTING_PAID, ALERT } from './ActivityFeedIcons.jsx'

export function getColorStyle(classes, activityItem) {
  let iconClassNameTuple = determineIconAndClassName(activityItem.kind)
  let style = ''
  if (activityItem.has_warning || iconClassNameTuple.className === ALERT) {
    style = classes.redStyle
  } else if (iconClassNameTuple.className === GETTING_PAID) {
    style = classes.greenStyle
  }
  return style
}
